const keys = {
  additionalDriver: {
    additionalDriver: 'the additional driver',
    yearsOld: 'Years old',
    actions: {
      add: 'Add an additional driver',
      edit: 'Edit',
      remove: 'Remove',
    },
    fields: {
      firstName: 'First name',
      lastName: 'Last name',
      birthday: 'Birthday',
      situation: 'How would you describe this driver’s situation?',
      gender: 'Gender',
      relationship: 'Relationship',
      ageFirstDriverLicense:
        'At what age did this driver first obtain a driver’s licence (excluding temporary licence)?',
      occupation: 'Occupation',
      workplace: 'Workplace',
      schoolName: 'School name',
    },
    titles: {
      main: 'You can add up to two additional drivers',
      claims: 'Please add every accident this driver has been involved in the last 6 years.',
      drivingConvictions: 'Please add every conviction this driver has had in the last 5 years.',
    },
    placeholders: {
      firstName: 'First name',
      lastName: 'Last name',
      birthday: 'dd/mm/yyyy',
      relationship: 'ex. Married',
      ageFirstDriverLicense: 'ex. 18',
      occupation: 'ex. Medical',
      workplace: 'ex. Starbucks',
      schoolName: 'ex. Dawson College',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
